import React from 'react';
import { Theme } from '../../../../Enums/Theme.enum';
import Button from '../../../../Components/Button/Button';
import useStripe from '../../Hooks/useStripe';
import OverlayLoading from '../../../../Components/OverlayLoading';

const StripeRegistrationButton: React.FC = () => {
	const { canSetupStripe, handleStripeRegistration, isLoading } = useStripe();

	if (canSetupStripe) {
		return (
			<>
				{isLoading && <OverlayLoading />}
				<Button
					title='component.stripeRegistrationButton.title'
					theme={Theme.BLUE}
					style={{ width: 'fit-content' }}
					onClick={handleStripeRegistration}
				/>
			</>
		);
	}

	return <></>;
};

export default StripeRegistrationButton;
